module.exports = __webpack_public_path__ + "img/DE02349.3a871e27.png";